import type { RouteRecordRaw } from 'vue-router';

export const cMANUTENCAO_ROUTES = {
  error404: {
    path: 'Error404',
    name: 'Error404',
    component: () => import('@/components/manutencao/Error404Page.vue'),
  },

  error500: {
    path: 'Error500',
    name: 'Error500',
    component: () => import('@/components/manutencao/Error500Page.vue'),
  },

  emConstrucao: {
    path: 'EmConstrucao',
    name: 'EmConstrucao',
    component: () => import('@/components/manutencao/EmConstrucaoPage.vue'),
  },

  forbiddenPerfilAcessoERP: {
    path: 'forbidden_erp',
    name: 'ForbiddenERP',
    component: () => import('@/components/manutencao/ForbiddenPefilAcessoERP.vue'),
  },

  forbiddenPerfilAcessoAdmin: {
    path: 'forbidden_api',
    name: 'ForbiddenAdmin',
    component: () => import('@/components/manutencao/ForbiddenPefilAcessoAdmin.vue'),
  },
};

export const manutencaoRoutes: Array<RouteRecordRaw> = [
  {
    path: cMANUTENCAO_ROUTES.error404.path,
    name: cMANUTENCAO_ROUTES.error404.name,
    component: cMANUTENCAO_ROUTES.error404.component,
  },
  {
    path: cMANUTENCAO_ROUTES.error500.path,
    name: cMANUTENCAO_ROUTES.error500.name,
    component: cMANUTENCAO_ROUTES.error500.component,
  },
  {
    path: cMANUTENCAO_ROUTES.emConstrucao.path,
    name: cMANUTENCAO_ROUTES.emConstrucao.name,
    component: cMANUTENCAO_ROUTES.emConstrucao.component,
  },

  {
    path: cMANUTENCAO_ROUTES.forbiddenPerfilAcessoAdmin.path,
    name: cMANUTENCAO_ROUTES.forbiddenPerfilAcessoAdmin.name,
    component: cMANUTENCAO_ROUTES.forbiddenPerfilAcessoAdmin.component,
  },

  {
    path: cMANUTENCAO_ROUTES.forbiddenPerfilAcessoERP.path,
    name: cMANUTENCAO_ROUTES.forbiddenPerfilAcessoERP.name,
    component: cMANUTENCAO_ROUTES.forbiddenPerfilAcessoERP.component,
  },
];
